import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";

type TourFlag = "has_seen_dashboard_tour" | "has_seen_report_tour";

export interface TourFlags {
  dashboardSeen: boolean;
  reportSeen: boolean;
}

export async function fetchTourFlags(): Promise<TourFlags> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    return { dashboardSeen: true, reportSeen: true };
  }

  const { data, error } = await supabase
    .from("profiles")
    .select("has_seen_dashboard_tour, has_seen_report_tour")
    .eq("user_id", user.id)
    .maybeSingle();

  if (error) {
    logger.error("Failed to fetch tour flags", error);
    return { dashboardSeen: true, reportSeen: true };
  }

  return {
    dashboardSeen: Boolean(data?.has_seen_dashboard_tour),
    reportSeen: Boolean(data?.has_seen_report_tour),
  };
}

export async function markTourSeen(flag: TourFlag): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { error } = await supabase
    .from("profiles")
    .update({ [flag]: true })
    .eq("user_id", user.id);

  if (error) {
    logger.error("Failed to mark tour as seen", { flag, error });
  }
}
